import { Subscription } from '@models/subscription.model';
 
import { useMutation, useQuery } from 'react-query';
import api from '../api/instance';

const nameSpace = '/settings/subscriptions';

const show = (subscriptionId) => {
  return api
    .get<Subscription>(`${nameSpace}/${subscriptionId}`)
    .then((data) => new Subscription().deserialize(data))
    .catch((e) => Promise.reject(e));
};


export const SubscriptionService = {
  show,
};

export const usePostBillingAddress = ({ callback }: { callback: any }) => {
  return useMutation(
    async ({
      payload,
      subscriptionId,
    }: {
      payload: any;
      subscriptionId: number;
    }) => {
      return await api.put(
        `${nameSpace}/${subscriptionId}/billing_address`,
        payload,
      );
    },
    {
      onSuccess: (response: any) => {
        if (callback) callback(true, response);
      },
      onError: (error: any) => {
        if (callback) callback(false, error);
      },
    },
  );
};